import React, { FC } from 'react';
import { FlexProps, Flex, Box, Container } from '@chakra-ui/react';

interface I extends FlexProps {
  children: any;
  isDineIn?: boolean;
}

export const BasicHeaderLayout: FC<I> = (props) => {
  const { children, isDineIn, ...rest } = props;
  return (
    <Box bg="white" w="100vw" boxShadow="base" borderColor="blackAlpha.100">
      <Container maxW="100%" px={{ base: 2, md: 4 }} py={2} h="100%">
        <Flex
          justify={isDineIn ? 'center' : 'space-between'}
          align="center"
          wrap="nowrap"
          {...rest}
        >
          {children}
        </Flex>
      </Container>
    </Box>
  );
};
